module.exports = require("@mui/icons-material/Cached");